// extracted by mini-css-extract-plugin
export default {"check-normal":"FormCheck_check-normal__SuPzk","check-box":"FormCheck_check-box__B3prT"};